import Image from 'next/image'
import React from 'react'

import HappyTeamIcon from '../../atoms/icons/icon/icons/HappyTeamIcon'
import HomeFilledIcon from '../../atoms/icons/icon/icons/HomeFilledIcon'
import RestaurantIcon from '../../atoms/icons/icon/icons/RestaurantIcon'
import TrainIcon from '../../atoms/icons/icon/icons/TrainIcon'
import { ServiceProviderCategoryEnum } from '../../../lib/graphql'

const iconProps: React.SVGProps<SVGSVGElement> = {
  height: 24,
  width: 24,
  color: 'var(--clr-brand-400)',
}

const IconWrapper = ({
  children,
  height,
  width,
}: {
  children: React.ReactNode
  height: number
  width: number
}) => {
  return (
    <div
      style={{
        backgroundColor: 'var(--clr-grey-800)',
        borderRadius: '4px',
        height,
        width,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  )
}

export function ServiceProvisionImage({
  serviceCategory,
  uri,
  height = 45,
  width = 45,
}: Readonly<{
  serviceCategory: ServiceProviderCategoryEnum
  uri?: string
  height?: number
  width?: number
}>) {
  if (uri) {
    return (
      <Image
        src={uri}
        style={{ borderRadius: '4px', objectFit: 'cover', height, width }}
        alt='image'
        height={height}
        width={width}
        unoptimized
      />
    )
  }

  switch (serviceCategory) {
    case ServiceProviderCategoryEnum.ACTIVITY:
      return (
        <IconWrapper {...{ height, width }}>
          <HappyTeamIcon {...iconProps} />
        </IconWrapper>
      )
    case ServiceProviderCategoryEnum.RESTAURATION:
      return (
        <IconWrapper {...{ height, width }}>
          <RestaurantIcon {...iconProps} />
        </IconWrapper>
      )
    case ServiceProviderCategoryEnum.TRANSPORT:
      return (
        <IconWrapper {...{ height, width }}>
          <TrainIcon {...iconProps} />
        </IconWrapper>
      )
    case ServiceProviderCategoryEnum.HOUSE:
      return (
        <IconWrapper {...{ height, width }}>
          <HomeFilledIcon {...iconProps} />
        </IconWrapper>
      )
    default:
      return <> </>
  }
}
